import React from "react";
import { ScrollArea } from "../ui/scroll-area";
import AdminCheckbox from "../AdminCheckbox";

const AssignableItemsSection = ({
  assignableItems,
  selectedAssignableItems,
  onToggleAssignableItem,
  config,
}) => {
  return (
    <div className="flex flex-col h-full">
      <ScrollArea className="bg-customGrey px-4 pt-3 w-full flex-1">
        <h3 className="text-0.9 font-semibold mb-3 text-customBlue text-left">
          Assigned to {config.assignableItemLabel.toLowerCase()}:
        </h3>
        <div className="grid grid-cols-3">
          {assignableItems.map((item) => {
            const isChecked = selectedAssignableItems.has(item.id);

            return (
              <label
                key={`checkbox-${item.id}-${isChecked}`}
                className="flex items-start gap-2 p-1 rounded cursor-pointer hover:bg-blue-50 transition-colors duration-150"
              >
                <AdminCheckbox
                  checked={isChecked}
                  onChange={() => onToggleAssignableItem(item.id)}
                />
                <span className="select-none text-sm mt-1">{item.name}</span>
              </label>
            );
          })}
        </div>
      </ScrollArea>
    </div>
  );
};

export default AssignableItemsSection;
